﻿window.cObjetReservationArrhesMetier = function (objet) {
    var Me = this;
    this.data = objet.data;
    this.objet = objet;

    this.mGetLibBase = function () { return "Arrhes"; }
    this.mGetAttributBase = function () { return "les " }
    this.mGetNewLib = function () { return "Nouveaux arrhes"; }
    this.mGetLib1 = function (option) {
        var lib = "Arrhes " + objet.data.mt + "€"
        if (objet.data.id_doc_cpt_mode_reglement) {
            var objReg = objet.bddRef.getObjet("doc_cpt_mode_reglement", objet.data.id_doc_cpt_mode_reglement)
            var dataModeReg = objet.bddRef.mGetArray("mode_reglement").filter(function (o) { return o.id_mode_reglement == objReg.data.id_mode_reglement })[0]
            lib += " - réglé par " + dataModeReg.nom + " " + objReg.data.date_reglement.toDateIlya()
        } else if (objet.data.date_demande) {

        } else {

        }
        //var lib = objet.data.mt + "€"
        ////var modeReg = objet.bddRef.mGetArray("mode_reglement").filter(function (o) {
        ////    return o.id_mode_reglement == objet.data.id_mode_reglement
        ////})[0]
        ////if (modeReg.id_mode_reglement == 11) {
        ////    lib += " " + modeReg.nom
        ////    if (objet.data.id_centrale_reservation) {
        ////        var dataCentrale = objet.bddRef.mGetArray("centrale_reservation").filter(function (o) {
        ////            return o.id_centrale_reservation == objet.data.id_centrale_reservation
        ////        })[0]
        ////        if (dataCentrale) {
        ////            lib += " (" + dataCentrale.nom + ")"
        ////        }
        ////    }
        ////} else {
        ////    lib += " (" + modeReg.nom + ")"
        ////}
        ////if (objet.data.date_reglement) lib += " - réglé le " + objet.data.date_reglement.toDDMMAA()
        return lib
    }
    this.mGetLib2 = function () {
        return ""
    }

    this.mGetIcone = function (dataTemplate) {
        return $("<i class='fas fa-coins'></i>");
    }

   
}